export enum EModelApiPaths {
    API = '/api',
    CUSTOM_API_BASE = '/custom-api',
    SYSTEM_API_BASE = '/system-api',
    THIRD_PARTY_API_BASE = '/third-party',
}
